// extracted by mini-css-extract-plugin
module.exports = {"review-report-ifame":"review-report-ifame-7ef610a506c6bd99239fd7e96b955f0e","review-iframe":"review-iframe-1478e7b2113cfcd8f7eacf8b7d5b5cec"};